import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";

import SubNavPoint from "../subNavPoint/subNavPoint";

import "./tabNavigation.scss";

const TabNavigation = ({ items }) => {
  const [swiper, setSwiper] = useState(null);
  const [nextDisabled, setNextDisabled] = useState(true);
  const [prevDisabled, setPrevDisabled] = useState(true);

  const updateSwiperControlls = () => {
    if (swiper) {
      setNextDisabled(swiper.isEnd);
      setPrevDisabled(swiper.isBeginning);
    }
  };

  const focusSlide = () => {
    if (swiper) {
      const i = swiper.slides.findIndex((slide) => (
        slide.childNodes[0].classList.contains("active")
      ));

      if (i > 0 && i < swiper.slidesGrid.length) {
        swiper.clickedIndex = i;
        swiper.slideTo(i, 300);
        swiper.translateTo(
          (swiper.slidesGrid[i]
            - (window.innerWidth / 2)
            + (swiper.slidesSizesGrid[i] / 2)) * -1,
          300,
        );
      }

      updateSwiperControlls();
    }
  };

  const initSwiper = () => {
    if (swiper) {
      setTimeout(() => {
        swiper.update();
        focusSlide();
      }, 500);
    }
  };

  return (
    <div className="tab-navigation container-md-down--fullwidth">
      <Swiper
        breakpoints={{
          0: {
            allowTouchMove: true,
            spaceBetween: 24,
          },
          992: {
            allowTouchMove: false,
            spaceBetween: 24,
          },
          1200: {
            allowTouchMove: false,
            spaceBetween: 30,
          },
        }}
        centeredSlidesBounds
        freeMode
        onResize={focusSlide}
        onSetTranslate={updateSwiperControlls}
        onSwiper={setSwiper}
        onAfterInit={initSwiper}
        slidesPerView="auto"
      >
        {items.map((item) => (
          <SwiperSlide key={item.id}>
            <SubNavPoint
              {...item}
              href={item.link}
              key={item.id}
              className={item.className}
              color="white"
            >
              {item.children || item.title}
            </SubNavPoint>
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        role="presentation"
        className={classNames(
          "swiper-button-prev",
          { "swiper-button-disabled": prevDisabled },
        )}
        onClick={() => {
          swiper.slidePrev();
        }}
      />
      <div
        role="presentation"
        className={classNames(
          "swiper-button-next",
          { "swiper-button-disabled": nextDisabled },
        )}
        onClick={() => {
          swiper.slideNext();
        }}
      />
    </div>
  );
};

TabNavigation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    state: PropTypes.oneOfType([PropTypes.object]),
    title: PropTypes.string.isRequired,
  })).isRequired,
};

export default TabNavigation;
